import { render, staticRenderFns } from "./insuranceprintprofile.vue?vue&type=template&id=06d6c51c"
import script from "./insuranceprintprofile.vue?vue&type=script&lang=js"
export * from "./insuranceprintprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports